<div class="custom-elevation" flex="row">
    <div fxFlex="0 0 50%">
        <img mat-card-image src="../../../assets/images/no-installation.png" style="padding: 29px 27px 34px; max-width: 245px;">
    </div>
    <div class="text-div">
        {{ 'detailsPage.notFound' | translate }}
    </div>
</div>
